import { t } from "i18next";
import { useEffect, useState } from "react";
import Draggable from "react-draggable";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import swal from "sweetalert";
import { isUrdu, LoadingSpinner } from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString } from "../helper/Components";
import { GetSelectedLanguage } from "../helper/Method";
import { ApiNotifications } from "./ApiNotifications";
import GenericSwitch from "../shared/GenericSwitch";

const toCamelCase = (str) => str.charAt(0).toLowerCase() + str.slice(1);

const AddLfcNotificationComment = ({
  params,
  notificationId,
  handleSubmitBack,
  setCommentModel,
}) => {
  const responsibilityName = encryptStorage.getItem("responsibilityName");
  const toggle = () => setCommentModel(false);
  const [values, setValues] = useState({});
  const [formValues, setFormValues] = useState({
    comment: "",
    hasInformed: false,
  });
  const [errors, setErrors] = useState(formValues);
  const [loading, setLoading] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const camelCaseData = {};
    for (let key in params) {
      camelCaseData[toCamelCase(key)] = params[key];
    }
    setValues(camelCaseData);
  }, [params]);

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.comment = formValues.comment ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const responsibilityFieldMap = {
    نقیب: {
      feedbackKey: "naqeebFeedback",
      informedKey: "hasNaqeebInformedRafiqForTawajah",
    },
    "مقامی امیر": {
      feedbackKey: "muqamiAmeerFeedback",
      informedKey: "hasMuqamiAmeerInformedRafiqForTawajah",
    },
    "امیر حلقہ": {
      feedbackKey: "ameerHalqaFeedback",
      informedKey: "hasAmeerHalqaInformedRafiqForTawajah",
    },
    "نائب ناظم اعلیٰ برائے زون": {
      feedbackKey: "naibNazimAllaFeedBack",
      informedKey: "hasNaibNazimAllaInformedRafiqForTawajah",
    },
    "ناظم اعلیٰ": {
      feedbackKey: "nazimAllaFeedBack",
      informedKey: "hasNazimAllaInformedRafiqForTawajah",
    },
    "امیر تنظیم اسلامی": {
      feedbackKey: "ameerMohtaramFeedBack",
      informedKey: "hasAmeerMohtaramInformedRafiqForTawajah",
    },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const roleConfig = responsibilityFieldMap[responsibilityName];

    if (roleConfig) {
      if (formValues.comment !== undefined) {
        values[roleConfig.feedbackKey] = formValues.comment;
      }
      if (formValues.hasInformed !== undefined) {
        values[roleConfig.informedKey] = formValues.hasInformed;
      }
    }

    if (validate()) {
      setLoading(true);
      ApiNotifications()
        .UpdateLfcNotificationComments(notificationId, values)
        .then((res) => {
          handleSubmitBack();
          swal({
            title: t("added_comment"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "success",
            buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
          });

          setLoading(false);
          toggle();
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    }
  };

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen={true} className="inmodal" autoFocus={false}>
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="member_member_detail_course_comment" />
        </ModalHeader>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label>
                  <GetLanguageString props="member_member_detail_course_comment" />
                </Label>
                <Input
                  autoFocus
                  type="text"
                  name="comment"
                  className={
                    isUrdu(formValues.comment) ? "no-drag ur" : "no-drag"
                  }
                  onChange={handleInputChange}
                  {...(errors?.comment && { invalid: true })}
                />
                {errors?.comment && (
                  <FormFeedback>
                    <h4>{errors?.comment}</h4>
                  </FormFeedback>
                )}
              </FormGroup>
              <FormGroup>
                <Row>
                  <Col md="10">
                    <Label
                      className="col-form-label ur"
                      style={{ fontSize: 15 }}
                    >
                      کیا توجہ طلب امور پر متعلقہ رفیق کو موثر انداز سے توجہ
                      دلائی گئ ہئے؟
                    </Label>
                  </Col>
                  <Col md="2" style={{ marginTop: 5 }}>
                    <GenericSwitch
                      label="hasInformed"
                      value={formValues.hasInformed}
                      setValues={setFormValues}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={toggle}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit">
                <GetLanguageString props="common_save_changes" />
              </Button>{" "}
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default AddLfcNotificationComment;
